import * as _ from "lodash";
import * as log from "loglevel";

import { action, autorun, computed, observable, runInAction } from "mobx";
import { Agent } from "../services/agent";
import { SystemMessage } from "./models/system-message";

export class SystemMessageStore {
	@observable messages: SystemMessage[] = [];
	@observable loading = false;
	@observable activeMessage: SystemMessage = null;
	@observable preview : boolean = false;

	@action async loadSystemMessage(){
		this.loading = true;
		let result = await Agent.SystemMessage.get();
		let messages : Array<SystemMessage> = [];
		result.forEach(message => {
			messages.push(new SystemMessage(message));
		});
		const activeMsgs = messages.sort((a, b) => b.id - a.id ).map(msg => this.checkMessage(msg)).filter(msg => msg);
		const alertId = window.localStorage.getItem("jump-system-message-alert");
		const showMsg = activeMsgs.length > 0 && (alertId == null || alertId != activeMsgs[0].id.toString());
		runInAction(() => {
			this.messages = messages;
			if(showMsg) {
				this.activeMessage = activeMsgs[0];
			}
			this.loading = false;
		});
	}

	@action async addMessage(message: SystemMessage){
		this.loading = true;
		await Agent.SystemMessage.add(message);
		runInAction(() => {
			this.loading = false;
		});
	}


	@action async deleteMessage(message: SystemMessage){
		this.loading = true;
		await Agent.SystemMessage.delete(message.id);
		runInAction(() => {
			this.loading = false;
		});
	}

	@action async previewMessage(message : SystemMessage){
		const msg = this.checkMessage(message, true);
		if(msg) {
			this.preview = true;
			this.activeMessage = msg;
		}
	}

	@action dismissMessage() {
		if(this.preview) {
			this.preview = false;
		}
		else {
			window.localStorage.setItem("jump-system-message-alert", this.activeMessage.id.toString());
		}
		this.activeMessage = null;
	}

	checkMessage(message: SystemMessage, preview: boolean = false) {
		const startDate = new Date(message.startDate).valueOf();
		const endDate = new Date(message.endDate).valueOf();
		const now = Date.now();
		if(preview || (startDate <= now && endDate >= now)) {
			return message;
		}
		return null;
	}
}



// WEBPACK FOOTER //
// ./src/stores/system-message-store.ts